import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IEngineInfo, TEST_AGENT_INFO } from '../model/model';
import { AgentListComponent } from '../agent-list/agent-list.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Device, IDeviceData, TestMode } from '@nrwl/common-lib';

@Component({
  selector: 'nrwl-agent-picker',
  templateUrl: './agent-picker.component.html',
  styleUrls: ['./agent-picker.component.scss']
})
export class AgentPickerComponent implements OnInit, OnChanges {
  @Input() testType: string;
  @Input() editMode = false;
  @Input() originatorDevice: Device;
  @Input() destinationDevice: Device;
  @Input() testMode: string;
  @Input() direction: string;
  @Input() originatorMultiSelection = false;
  @Input() showTestMode = true;
  @Input() showDirections = false;
  @Input() loopbackType = '';
  @Input() showDestination = false;
  @Input() showDirectionIcons? = false;
  @Input() selectReflectorDevice = false;
  @Output() emitAgents = new EventEmitter();

  //eslint-disable-next-line
  originatorValue: BehaviorSubject<any>;

  //eslint-disable-next-line
  destinationValue: BehaviorSubject<any>;
  agentTypes = [];
  agentCapabilityCheck = null;
  destTypes = [];
  destAgentCapabilityCheck = null;
  destinationFilter = null;
  originatorConfiguration = {
    title: '',
    label: '',
    message: 'Choose the first endpoint for the test',
    icon: 'mdi mdi-star-four-points',
    class: 'customClass'
  };
  destinationConfiguration = {
    title: '',
    label: '',
    message: 'Choose the second endpoint for the test',
    icon: 'mdi mdi-map-marker',
    class: 'customClass'
  };
  selectedTestMode: string;
  //eslint-disable-next-line
  testInfo: any;
  selectedDestination = [];
  selectedOriginator = [];
  //eslint-disable-next-line
  originatorDialogRef: MatDialogRef<any>;
  //eslint-disable-next-line
  destinationdialogRef: MatDialogRef<any>;
  availableDirections = [];
  testModeOptions = TestMode;
  constructor(private dialog: MatDialog) {
    //eslint-disable-next-line
    this.originatorValue = new BehaviorSubject<any>([]);
    //eslint-disable-next-line
    this.destinationValue = new BehaviorSubject<any>([]);
  }

  ngOnInit(): void {
    this.testInfo = TEST_AGENT_INFO[this.testType];
    this.selectedTestMode = this.testInfo[0].testMode;
    this.availableDirections = this.testInfo[0].directions;
    this.agentTypes = this.testInfo[0].agentTypes;
    this.agentCapabilityCheck = this.testInfo[0].agentCapabilityCheck || null;
    this.destTypes = this.testInfo[0].destAgentTypes || this.testInfo[0].agentTypes;
    this.destAgentCapabilityCheck =
      this.testInfo[0].destAgentCapabilityCheck || this.testInfo[0].agentCapabilityCheck || null;
    this.destinationFilter = this.testInfo[0].destinationFilter || null;
    this.setSelectedAgentInfo();
    this.pickTestModeCapability(this.testMode);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.originatorDevice) {
      this.originatorValue.next([]);
      this.selectedOriginator = [];
    }
    if (!this.destinationDevice) {
      this.destinationValue.next([]);
      this.selectedDestination = [];
    }
    if (this.testInfo && changes.testMode && changes.testMode.currentValue) {
      this.onTestModeChange(this.testMode);
    }
    if (this.testInfo && changes.direction && changes.direction.currentValue) {
      this.onDirectionChange(this.direction);
    }
  }

  setSelectedAgentInfo(): void {
    if (Array.isArray(this.originatorDevice)) {
      const labelArray = [];
      this.originatorDevice.forEach(item => {
        const label = {
          title: item.getUniqueName(),
          label: item.getPhyId()
            ? item.getModel() + ' - ' + item.getPhyId().toUpperCase()
            : item.getModel()
        };
        labelArray.push(label);
        this.selectedOriginator.push({ dataItem: item.deviceData, ...item.deviceData });
      });
      this.originatorValue.next(labelArray);
    } else if (this.originatorDevice) {
      const label = {
        title: this.originatorDevice.getUniqueName(),
        label: this.originatorDevice.getPhyId()
          ? this.originatorDevice.getModel() +
            ' - ' +
            this.originatorDevice.getPhyId().toUpperCase()
          : this.originatorDevice.getModel()
      };
      this.originatorValue.next([label]);
      this.selectedOriginator = [
        { dataItem: this.originatorDevice.deviceData, ...this.originatorDevice.deviceData }
      ];
    }
    if (this.destinationDevice) {
      const label = {
        title: this.destinationDevice.getUniqueName(),
        label: this.destinationDevice.getPhyId()
          ? this.destinationDevice.getModel() +
            ' - ' +
            this.destinationDevice.getPhyId().toUpperCase()
          : this.destinationDevice.getModel()
      };
      this.destinationValue.next([label]);
      this.selectedDestination = [
        { dataItem: this.destinationDevice.deviceData, ...this.destinationDevice.deviceData }
      ];
    }
  }
  viewOriginator(): void {
    this.originatorDialogRef = this.dialog.open(AgentListComponent, {
      width: '1000px',
      height: '660px',
      disableClose: true,
      data: {
        singleSelection: !this.originatorMultiSelection,
        filteredData: this.selectedDestination,
        agentTypes: this.agentTypes,
        agentCapabilityCheck: this.agentCapabilityCheck,
        selectedDevices: this.selectedOriginator,
        selectedTestMode: this.selectedTestMode,
        testType: this.testType,
        selectReflectorDevice: this.selectReflectorDevice
      }
    });
    this.originatorDialogRef.afterClosed().subscribe(selectedRows => {
      if (selectedRows) {
        this.selectedOriginator = selectedRows;
        this.setOriginatorData();
      }
    });
  }
  viewDestination(): void {
    this.destinationdialogRef = this.dialog.open(AgentListComponent, {
      width: '1000px',
      height: '660px',
      disableClose: true,
      data: {
        singleSelection: true,
        filteredData: this.selectedOriginator,
        agentTypes: this.destTypes,
        agentCapabilityCheck: this.destAgentCapabilityCheck,
        selectedDevices: this.selectedDestination,
        selectedTestMode: this.selectedTestMode,
        testType: this.testType,
        loopbackType: this.loopbackType,
        destinationFilter: this.destinationFilter,
        selectionMode: 'destination'
      }
    });
    this.destinationdialogRef.afterClosed().subscribe(selectedRows => {
      if (selectedRows) {
        this.selectedDestination = selectedRows;
        this.setDestinationData();
      }
    });
  }
  onTestModeChange(mode: string): void {
    this.pickTestModeCapability(mode);
    if (
      this.selectedOriginator.length &&
      !this.agentTypes.some(str =>
        this.selectedOriginator[0].subLabel.toLowerCase().includes(str.toLowerCase())
      )
    ) {
      this.originatorValue.next([]);
      this.selectedOriginator = [];
    }
    if (
      this.selectedDestination.length &&
      !this.agentTypes.some(str =>
        this.selectedDestination[0].subLabel.toLowerCase().includes(str.toLowerCase())
      )
    ) {
      this.destinationValue.next([]);
      this.selectedDestination = [];
    }
    this.updateAgentInfo();
    if (this.availableDirections) {
      this.direction = this.availableDirections[0]?.value;
    }
  }

  pickTestModeCapability(mode: string): void {
    const testInfo = this.testInfo.find(item => item.testMode === mode);
    this.selectedTestMode = testInfo.testMode;
    this.availableDirections = testInfo.directions;
    this.showDestination = testInfo.showDestination;
    this.agentTypes = testInfo.agentTypes;
    this.agentCapabilityCheck = testInfo.agentCapabilityCheck || null;
    this.destTypes = testInfo.destAgentTypes || testInfo.agentTypes;
    this.destAgentCapabilityCheck =
      testInfo.destAgentCapabilityCheck || testInfo.agentCapabilityCheck || null;
    this.destinationFilter = testInfo.destinationFilter || null;
  }

  setOriginatorData(): void {
    this.originatorValue.next(this.selectedOriginator);
    this.updateAgentInfo();
  }

  setDestinationData(): void {
    this.destinationValue.next(this.selectedDestination);
    this.updateAgentInfo();
  }

  updateAgentInfo(): void {
    this.onEmitValue();
  }

  // onEmitValue(): void {
  //   const agentInfo = {
  //     testMode: this.selectedTestMode,
  //     originatorId: null,
  //     destinationId: null,
  //     'engine-a-info': null,
  //     'engine-b-info': null,
  //     showDestination: this.showDestination,
  //     isValid: false
  //   };
  //   if (this.selectedOriginator.length) {
  //     agentInfo.originatorId = this.selectedOriginator[0].id;
  //     agentInfo['engine-a-info'] = this.getEngineInfo(this.selectedOriginator[0].dataItem);
  //     if (!this.showDestination) {
  //       agentInfo.isValid = true;
  //     }
  //   }
  //   if (this.showDestination && this.selectedDestination.length) {
  //     agentInfo['destinationId'] = this.selectedDestination[0].id;
  //     agentInfo['destinationIP'] = this.selectedDestination[0].ip;
  //     agentInfo['engine-b-info'] = this.getEngineInfo(this.selectedDestination[0].dataItem);
  //     if (agentInfo.originatorId) {
  //       agentInfo.isValid = true;
  //     }
  //   }
  //   this.emitAgents.emit(agentInfo);
  // }

  onEmitValue(): void {
    let agentInfos = [];

    if (this.selectedOriginator.length) {
      this.selectedOriginator.forEach(originator => {
        const agentInfo = {
          testMode: this.selectedTestMode,
          direction: this.direction || null,
          originatorId: originator.id,
          destinationId: null,
          'engine-a-info': this.getEngineInfo(originator.dataItem),
          'engine-b-info': null,
          showDestination: this.showDestination,
          isValid: false
        };

        if (!this.showDestination) {
          agentInfo.isValid = true;
        }

        if (this.showDestination && this.selectedDestination.length) {
          this.selectedDestination.forEach(destination => {
            const destinationAgentInfo = { ...agentInfo }; // Clone the current agentInfo
            destinationAgentInfo['destinationId'] = destination.id;
            destinationAgentInfo['destinationIP'] = destination.ip;
            destinationAgentInfo['engine-b-info'] = this.getEngineInfo(destination.dataItem);
            if (destinationAgentInfo.originatorId) {
              destinationAgentInfo.isValid = true;
            }
            agentInfos.push(destinationAgentInfo);
          });
        } else {
          agentInfos.push(agentInfo);
        }
      });
    } else {
      agentInfos = [
        {
          testMode: this.selectedTestMode,
          direction: this.direction || null,
          originatorId: null,
          destinationId: null,
          'engine-a-info': null,
          'engine-b-info': null,
          showDestination: this.showDestination,
          isValid: false
        }
      ];
    }

    if (this.originatorMultiSelection) {
      this.emitAgents.emit(agentInfos);
    } else {
      this.emitAgents.emit(agentInfos[0]);
    }
  }

  //eslint-disable-next-line
  getEngineInfo(deviceData: IDeviceData): IEngineInfo {
    let phyInfo;
    const engineInfo: any = {};
    if (deviceData?.capabilities?.phy) {
      phyInfo = deviceData?.capabilities?.phy;
    } else if (deviceData?.capabilities?.['phy-list']) {
      phyInfo = deviceData?.capabilities?.['phy-list'].find(
        item => item['phy-id'] === deviceData.phyId
      );
    }
    const port =
      deviceData?.connections?.[0]?.uri.split(':')[2] === '0' && deviceData.comMode === 'firewall'
        ? 443
        : deviceData?.connections?.[0]?.uri.split(':')[2];
    engineInfo['agent-type'] = deviceData?.type;
    engineInfo['engine-type'] = deviceData?.model?.model;
    engineInfo['address'] = deviceData?.connections
      ? deviceData?.connections[0]?.uri.split(':')[1].replace('//', '')
      : null;
    engineInfo['port'] = port;
    engineInfo['test-ip'] = phyInfo?.['default-test-ip'] ? phyInfo['default-test-ip'] : null;
    if (phyInfo?.['default-test-mask']) {
      engineInfo['test-subnet-mask'] = phyInfo['default-test-mask'];
    }
    if (phyInfo?.['default-test-gateway']) {
      engineInfo['test-gateway'] = phyInfo['default-test-gateway'];
    }
    return engineInfo;
  }

  onDirectionChange(direction: string): void {
    this.updateAgentInfo();
  }

  get isExternUrlEnabled(): boolean {
    return (
      this.testMode === TestMode.MA_TO_EXTERNAL && this.direction !== TestMode.UPLOAD_AND_DOWNLOAD
    );
  }

  isDirectionEditable(): boolean {
    return this.editMode && this.testType !== 'http' && this.testType !== 'ftp';
  }
}
